// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../../../node_modules/less-loader/dist/cjs.js!../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Prize Pop Rules Tab CSS Module
 * Prize Pop-specific rules content styles
 */
.RHgXx9y54IOy86z09GC4 {
}
.lcnHQVSO3nIEOCPo4JUY {
}
.tlFt1qmUEx8dWMsp6Qcw {
}
.Q1CPLBDizZlyB6bop6Be {
}
.apbLvi_D7ZEK0qtgiu2R {
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/prizePop/tabs/RulesTab/PrizePopRulesContent/PrizePopRulesContent.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA","sourcesContent":["/**\n * Prize Pop Rules Tab CSS Module\n * Prize Pop-specific rules content styles\n */\n.title {\n  composes: title from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.section {\n  composes: section from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.highlightedText {\n  composes: highlightedText from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.timeSlotList {\n  composes: list from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.timeSlotItem {\n  composes: listItem from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `RHgXx9y54IOy86z09GC4 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["title"]}`,
	"section": `lcnHQVSO3nIEOCPo4JUY ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`,
	"highlightedText": `tlFt1qmUEx8dWMsp6Qcw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["highlightedText"]}`,
	"timeSlotList": `Q1CPLBDizZlyB6bop6Be ${___CSS_LOADER_ICSS_IMPORT_0___.locals["list"]}`,
	"timeSlotItem": `apbLvi_D7ZEK0qtgiu2R ${___CSS_LOADER_ICSS_IMPORT_0___.locals["listItem"]}`
};
export default ___CSS_LOADER_EXPORT___;
